import React, { FC } from 'react'
import { LogoTransfix } from 'transfix-ui/components/LogoTransfix'
import { Box, makeStyles, LinearProgress } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'

const useFleetPlannerLoadingStyles = makeStyles({
  linearProgressContainer: {
    paddingTop: '24px',
  },
  linearProgress: {
    color: 'black',
  },
  root: {
    '& .MuiLinearProgress-colorPrimary': {
      backgroundColor: brandColors.coolGray1,
    },
    '& .MuiLinearProgress-barColorPrimary': {
      backgroundColor: 'black',
    },
  },
})

export const FleetPlannerLoading: FC = () => {
  const classes = useFleetPlannerLoadingStyles()

  return (
    <Box className={classes.root} data-test='fleet-planner-loading'>
      <LogoTransfix color='black' width={174} />
      <Box className={classes.linearProgressContainer}>
        <LinearProgress className={classes.linearProgress} />
      </Box>
    </Box>
  )
}
